import React from "react"
import PlaneImg from "../../../../assets/avia/search/plane.png"
import { cn } from "../../../../lib"
import { MapPin } from "lucide-react"

const FormFieldWrapper = ({ children, isFrom = true, t }) => {
  return (
    <div className="flex items-center gap-1 flex-1 basis-0 min-w-0 z-10 bg-surface-main relative h-[53px] pt-3">
      <span className="absolute top-[6px] left-0 text-[10px] font-medium text-app-content-subtle whitespace-nowrap bg-surface-main px-0.5 leading-none z-10 pointer-events-none rounded-xs">
        {t(isFrom ? "admin.departure_from_v3" : "filter.to_where")}
      </span>

      <div className="flex items-center gap-1 shrink-0">
        <MapPin size={18} className="text-app-content-subtle" />
      </div>

      <div className="flex-1 min-w-0">{children}</div>
    </div>
  )
}
export default FormFieldWrapper
